export const API_HOHOLOK = "https://hoholok.rotendaokab.go.id/api/";
//"https://hoholok.rotendaokab.go.id/api/";

//"http://localhost:5000/api/";
export const HOHOLOK_UPLOADS = "https://hoholok.rotendaokab.go.id";

export const PERANGKAT_DAERAH = API_HOHOLOK + "pd/";
export const ANALISIS_JABATAN = API_HOHOLOK + "anjab/";

export const EFEKTIFITAS = API_HOHOLOK + "efektifitas/";

export const ADMINS_LOGIN = API_HOHOLOK + "admin/login";
export const ADMINS_LOGOUT = API_HOHOLOK + "admin/logout";
export const ADMINS_TOKEN = API_HOHOLOK + "admin/token";
export const POST_ANJAB = API_HOHOLOK + "post/anjab/";
export const GET_ANJAB = API_HOHOLOK + "progress/anjab/";

export const ANALISIS_BEBAN_KERJA = API_HOHOLOK + "abk/";
export const POST_ABK = API_HOHOLOK + "post/abk/";
export const GET_ABK = API_HOHOLOK + "progress/abk/";
export const GET_NOTIF = API_HOHOLOK + "notifikasi/";
export const GET_AKTIVITY = API_HOHOLOK + "useraktivity/";

export const API_TIMEOUT = 120000;
